module.exports = __webpack_public_path__ + "static/media/BG_PDJ_Coaching.a05cc6e7.jpg";